import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Modal } from '../../components';
import IconCard from '../../components/SavedCardDetails/IconCard/IconCard';
import TapCardElement from '../../components/TapCardElement/TapCardElement.js';
import StripeCardElement from '../../components/StripeCardElement/StripeCardElement.js';
import css from './SubscriptionPlan.module.css';

const SubscriptionPlanModals = ({
  // Success Modal
  successOpen,
  successAmount,
  handleCloseSuccessModal,

  // Payment Modal
  paymentModalOpen,
  selectedPlan,
  cardGateway,
  handleClosePaymentModal,
  setCardGateway,
  onInitiatePayment,
  currentUser,
  handleSubmitTap,
  handleSubmitStripe,
  config,
  payinTotal,
  submitting,
  setSubmitting,
  renderPrice,

  // Confirm Modal
  confirmModalOpen,
  confirmModalTitle,
  confirmModalMessage,
  confirmModalIsAlert,
  confirmModalCancelText,
  confirmModalConfirmText,
  confirmModalAction,
  handleCloseConfirmModal,

  // UI scrolling
  onManageDisableScrolling,
}) => {
  const intl = useIntl();

  const renderCardGatewaySelector = () => {
    return (
      <div className={css.gatewaySelector}>
        <div className={css.gatewayContainer}>
          <div
            className={`${css.gatewayCard} ${cardGateway === 'tap' ? css.gatewayCardActive : ''}`}
            onClick={() => setCardGateway('tap')}
          >
            <div className={css.gatewayCardLabel}>
              <FormattedMessage
                id="CheckoutPage.payUsingTap"
                defaultMessage="Credit / Debit Card (TAP)"
              />
            </div>
          </div>
          <div
            className={`${css.gatewayCard} ${
              cardGateway === 'stripe' ? css.gatewayCardActive : ''
            }`}
            onClick={() => setCardGateway('stripe')}
          >
            <div className={css.gatewayCardLabel}>
              <FormattedMessage
                id="CheckoutPage.payUsingStripe"
                defaultMessage="Credit / Debit Card (Stripe)"
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {/* Wallet Credit Success Modal */}
      <Modal
        id="walletCreditSuccess"
        isOpen={successOpen}
        onClose={handleCloseSuccessModal}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
        className={css.modal}
      >
        <div className={css.withdrawSuccess}>
          <IconCard type="submiticon" />
          <div className={css.successTitle}>
            <FormattedMessage id="SubscriptionPlan.modal.successTitle" />
          </div>
          <div className={css.successSubtitle}>
            <FormattedMessage
              id="SubscriptionPlan.modal.successBody"
              values={{ amount: successAmount }}
            />
          </div>
        </div>
      </Modal>

      {/* Payment Gateway Modal */}
      <Modal
        id="paymentModal"
        isOpen={paymentModalOpen}
        onClose={handleClosePaymentModal}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
        className={css.paymentModal}
      >
        <div className={css.paymentModalContent}>
          <div className={css.paymentModalHeader}>
            <h2 className={css.paymentModalTitle}>
              <FormattedMessage
                id="SubscriptionPlan.paymentModal.title"
                defaultMessage="Complete Payment"
              />
            </h2>
            {selectedPlan && (
              <div className={css.selectedPlanInfo}>
                <span className={css.planNameModal}>{selectedPlan.name}</span>
                <span className={css.planPriceModal}>{renderPrice(selectedPlan.price)}</span>
              </div>
            )}
          </div>
          {renderCardGatewaySelector()}
          {cardGateway === 'tap' ? (
            <TapCardElement
              onInitiatePayment={onInitiatePayment}
              currentUser={currentUser}
              handleSubmitForm={values => handleSubmitTap(values, selectedPlan)}
              locale={config?.localization?.locale || 'en'}
              intl={intl}
              payinTotal={payinTotal}
              setSubmitting={setSubmitting}
            />
          ) : (
            <StripeCardElement
              publishableKey={config?.stripe?.publishableKey || ''}
              handleSubmitForm={values => handleSubmitStripe(values, selectedPlan)}
              payinTotal={payinTotal}
              progress={submitting}
              shouldDisable={submitting}
              currentUser={currentUser}
              intl={intl}
            />
          )}
        </div>
      </Modal>

      {/* Action / Warning Confirmation Modal */}
      <Modal
        id="confirmModal"
        isOpen={confirmModalOpen}
        onClose={handleCloseConfirmModal}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
        className={css.confirmModal}
      >
        <div className={css.confirmModalContent}>
          <h3 className={css.confirmModalTitle}>{confirmModalTitle}</h3>
          <p className={css.confirmModalMessage}>{confirmModalMessage}</p>
          <div className={css.confirmModalActions}>
            {!confirmModalIsAlert && (
              <button
                type="button"
                className={css.confirmModalCancelBtn}
                onClick={handleCloseConfirmModal}
              >
                {confirmModalCancelText || 'Cancel'}
              </button>
            )}
            <button
              type="button"
              className={css.confirmModalConfirmBtn}
              onClick={() => {
                if (confirmModalAction) confirmModalAction();
              }}
            >
              {confirmModalConfirmText || 'OK'}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SubscriptionPlanModals;
